import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const JoinCourseModal = ({ show, onHide, programTitle, handleJoinCourse }) => {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [action, setAction] = useState("");
  const [error, setError] = useState("");

  const handleActionSubmit = async () => {
    if (!action) {
      setError(t("choose_action_error"));
      return;
    }
    setError("");
    await handleJoinCourse(action);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("choose_action_for_course", { programTitle })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t("existing_progress_found")}</p>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <Form>
          <Form.Check
            type="radio"
            label={t("restore_progress")}
            value="restore"
            checked={action === "restore"}
            onChange={() => setAction("restore")}
          />
          <Form.Check
            type="radio"
            label={t("restart_course")}
            value="restart"
            checked={action === "restart"}
            onChange={() => setAction("restart")}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("cancel")}
        </Button>
        <Button variant="primary" onClick={handleActionSubmit}>
          {t("confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default JoinCourseModal;
